import type { DeliveryOption } from "@jti/commerce";

export const getInitialDeliveryOption = (deliveryOptions: DeliveryOption[]) => {
  return deliveryOptions.find((option) => option.defaultDelivery) ?? deliveryOptions[0];
};
